module.exports = __webpack_public_path__ + "assets/img/13_990_big.77198d29.jpg";